import type { VideoFormState } from '@openx/types/targeting/video';
import { useValidation as useMaxAdDurationValidation } from '../components/MaxAdDuration/hooks/useValidation';

export const useIsApplyDisabled = ({ adunit_max_duration_range }: VideoFormState) => {
  const { validation: maxAdDurationValidation } = useMaxAdDurationValidation(adunit_max_duration_range ?? null);

  if (!adunit_max_duration_range) return false;

  const isMaxAdDurationInvalid = maxAdDurationValidation.start.error || maxAdDurationValidation.end.error;
  const isDataIncomplete = adunit_max_duration_range.start === null || adunit_max_duration_range.end === null;

  return isMaxAdDurationInvalid || isDataIncomplete;
};
